import {
  PlanType, StripeProductLookupKeys,
  SubscriptionStatus,
} from '@showbie-socrative/socrative-utils';

import axios from '../localAxios';
import { baseSubscriptionURL } from './subscriptionURLs';

export interface Subscription {
  id: number;
  startDate: string;
  endDate: string;
  plan: PlanType;
  stripePlanid: string;
  status: SubscriptionStatus;
  cancelAtEndDate: boolean;
  totalSeats: number;
  lookupKey: StripeProductLookupKeys | null;
}

export async function getSubscriptions() {
  const subscriptionURL = baseSubscriptionURL();
  const { data } = await axios.get<Subscription[]>(subscriptionURL.href);

  return data;
}
